import { render, staticRenderFns } from "./SpotlightModulesLoader.vue?vue&type=template&id=a268bf58&scoped=true"
import script from "./SpotlightModulesLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotlightModulesLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpotlightModulesLoader.vue?vue&type=style&index=0&id=a268bf58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268bf58",
  null
  
)

export default component.exports